import { render, staticRenderFns } from "./Choujiang.vue?vue&type=template&id=51d959af&scoped=true"
import script from "./Choujiang.vue?vue&type=script&lang=js"
export * from "./Choujiang.vue?vue&type=script&lang=js"
import style0 from "./Choujiang.vue?vue&type=style&index=0&id=51d959af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d959af",
  null
  
)

export default component.exports